import {
  FluidPopoverConfig,
  FluidPopoverTranslationOptions,
  isNullOrUndefined,
} from '@lmig/fluid-core';

import { POPOVER_CHROME_INFO } from '../../constants/constants';
import { Utils } from '../utils';

// ================================================================ //
// -- Prop Sync

/**
 * When renaming a Prop, use this function to keep both the new
 * & deprecated Prop's values in-sync with each other. Typically used
 * to set the new Prop's value to the value of the deprecated Prop,
 * but can also be used to set the deprecated Prop's value from the
 * new Prop. Should be called initially in "connectedCallback()",
 * then called when either Prop is updated (i.e. via @Watch).
 * @param host - the host component (i.e. "this")
 * @param propName - the new Prop's name
 * @param deprecatedPropName - the deprecated Prop's name
 * @param updateDeprecated - should the new Prop set the value of the deprecated Prop?
 */
export const propSync = (
  host: any,
  propName: string,
  deprecatedPropName: string,
  updateDeprecated = false
): void => {
  if (updateDeprecated && !isNullOrUndefined(host[propName])) {
    host[deprecatedPropName] = host[propName];
  } else if (!isNullOrUndefined(host[deprecatedPropName])) {
    host[propName] = host[deprecatedPropName];
  }
};

// ================================================================ //
// -- Popover Prop Deprecation

export const validatePopoverProp = (
  host: HTMLElement,
  popoverConfig: string | FluidPopoverConfig,
  popoverProp: string, // Deprecated "popover" Prop,
  fluidTranslate?: FluidPopoverTranslationOptions
): FluidPopoverConfig => {
  if (!popoverConfig && !popoverProp) return;

  if (popoverProp) {
    typeof host.removeAttribute === 'function' &&
      host.removeAttribute('popover');

    Utils.deprecationWarning(
      host,
      'Prop',
      'popover',
      'popoverConfig',
      'string | FluidPopoverConfig',
      'string',
      POPOVER_CHROME_INFO
    );
  }

  if (typeof popoverConfig === 'string') {
    return { message: popoverConfig };
  } else {
    return {
      message: popoverProp,
      fluidTranslate,
      ...(popoverConfig as FluidPopoverConfig), // Merge here to override "message"
    };
  }
};
